import { Seo } from "@/components/Seo";
import { LinkedInMessageLink } from "@/features/contact/LinkedInMessageLink";
import { advisoryOffers } from "@/features/work/catalog";
import { headingText } from "@/lib/heading";

export function WorkWithJayPage() {
  return (
    <>
      <Seo
        title="Work with Jay"
        description="Workshops and conversations on digital strategy and delivery, the AI-first enterprise, the new world of work, The Human Organism as Algorithm, and intelligent automation."
        path="/work-with-jay"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Work with Jay</p>
        <h1>From the thinking to deployed prediction</h1>
        <p className="lede">
          I take clients from the argument to software that can be operated. Strategy has
          to become a system. Digitally enabled models are the thread.
        </p>
        <p>
          <LinkedInMessageLink className="button" />
        </p>
      </section>
      <section className="wrap grid-2">
        {advisoryOffers.map((offer) => (
          <article className="card" key={offer.slug} id={offer.slug}>
            <h2>{headingText(offer.title)}</h2>
            <p>
              <strong>Who it is for.</strong> {offer.audience}
            </p>
            <p>
              <strong>What we work through.</strong> {offer.through}
            </p>
            <p>
              <strong>What leaves the room.</strong> {offer.leaves}
            </p>
            <p className="meta">Trigger: {offer.trigger}</p>
          </article>
        ))}
      </section>
      <section className="wrap section" id="linkedin">
        <h2>Message on LinkedIn</h2>
        <p>
          That is the direct line. Outcomes are the ones earned in the room. Client
          names stay off this page.
        </p>
        <LinkedInMessageLink className="button" />
      </section>
    </>
  );
}
